import { render, staticRenderFns } from "./siGoodsList.vue?vue&type=template&id=7583c81d&"
import script from "./siGoodsList.vue?vue&type=script&lang=js&"
export * from "./siGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "siGoodsList.vue"
export default component.exports